var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottomHeaderCurve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 612,
    viewBox: "0 0 1728 612",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1055.29 56.2257C1425.89 -75.9151 1700.59 57.046 1860.75 127.454C1864.6 129.145 1866.41 133.482 1864.99 137.44L1820.85 261.285C1819.73 264.407 1816.81 266.52 1813.5 266.597L10.8843 308.672C7.15002 308.759 3.85246 306.251 2.93999 302.629L-26.4887 185.81C-27.904 180.192 -22.8452 175.016 -17.1348 175.994C550.995 273.273 720.835 175.481 1055.29 56.2257Z",
    fill: "#211452"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M782.899 555.606C410.645 688.136 135.128 553.659 -24.7784 483.58C-27.6921 482.303 -29.5 479.458 -29.5 476.277V283.666C-29.5 279.269 -25.9521 275.696 -21.5557 275.666L1880.98 262.424C1886.27 262.387 1890.14 267.4 1888.76 272.506L1824.9 509.414C1823.82 513.408 1819.72 515.896 1815.65 515.188C1243.74 415.939 1118.42 436.153 782.899 555.606Z",
    fill: "#211452"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomHeaderCurve);
export default __webpack_public_path__ + "static/media/bottomHeaderCurve.3faa7dfe9ebeb956365b86e032d51e0a.svg";
export { ForwardRef as ReactComponent };